import '@fontsource/poppins';

import CssBaseline from '@mui/material/CssBaseline';
import {
  StyledEngineProvider,
  ThemeProvider,
  createTheme,
} from '@mui/material/styles';

import React from 'react';

import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';

import { AnalyticsProvider } from '@contexts/analyticsContext';

// --- Global CSS Imports ---
// Global CSS styles, especially for third-party libraries like 'react-toastify',
// are imported here to ensure they are loaded only once and are available
// throughout the entire application.
import 'react-toastify/dist/ReactToastify.css';

import App from './App';
import { getThemeProps } from './config/theme';
import AuthContextProvider from './contexts/authContext';
import ContextProvidersHelper from './contexts/contextProvidersHelper';
import FormDataContextProvider from './contexts/formDataContext';
import TaskQueueContextProvider from './contexts/taskQueueContext';
import reportWebVitals from './reportWebVitals';

import './index.css';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);
const theme = createTheme(getThemeProps(rootElement));

root.render(
  <React.StrictMode>
    <ContextProvidersHelper
      providers={[
        <AuthContextProvider />,
        <FormDataContextProvider />,
        <TaskQueueContextProvider />,
        <AnalyticsProvider />,

        /* mui */
        <StyledEngineProvider injectFirst />,
        <ThemeProvider theme={theme} />,
      ]}
    >
      <CssBaseline />
      <App />
    </ContextProvidersHelper>
    <ToastContainer />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
